import * as React from 'react';
import PropTypes from 'prop-types';
// mui
import { alpha, styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';



import Skeleton from '@mui/material/Skeleton';
import { InputAdornment, Stack, Button, Avatar } from '@mui/material';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import popupsearch from '../../../../../assets/popupsearch.svg';

// components
import { useMutation, useQuery } from 'react-query';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
// api
import * as api from '../../../LockerMenu/component/api/index';
import BlurImageAvatar from '../BlueImageavatar/avatar';
import useETHPrice from '../useETHPrice';
import { useEffect } from 'react';
import { SecbotServices } from '../productConfig';


const SearchIcon = styled('img')`
  width: 18px;
  height: 18px;
  margin-right: 10px; 
`;
const LabelStyle = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1),
  fontSize: 12,
  fontWeight: 600,
  lineHeight: 1
}));

Search.propTypes = {
  onClose: PropTypes.func.isRequired,
  mobile: PropTypes.bool.isRequired,
  multiSelect: PropTypes.bool,
  selectedProducts: PropTypes.array,
  handleSave: PropTypes.func,
  onProductSelect: PropTypes.func, 
  baseUrl: PropTypes.string 
};


// Sample data for services (can be removed once API is working)
const sampleServices = [
];

export default function Search({ ...props }) {
const { onClose, mobile, multiSelect, selectedProducts, handleSave } = props;

  const [state, setstate] = React.useState({
    products: [],
    selected: selectedProducts || [],
    initialized: false,
    category: '',
    subCategory: '',
    shop: ''
  });
  const [ethPrice, setEthPrice] = React.useState(null);
  const { ethPrice: fetchedPrice, getloading, error } = useETHPrice();
  useEffect(() => {
    if (!getloading && !error && fetchedPrice) {
      setEthPrice(fetchedPrice);


    }
  }, [getloading, error, fetchedPrice]);

const navigate = useNavigate();
  const [search, setSearch] = React.useState('');

  

  // Fetch filters - this will use actual API once working
  const { data: filters, isLoading: filtersLoading } = useQuery(['get-search-filters'], () => api.getSearchFilters(), {
    // Fallback to prevent errors if API is not available
    onError: () => {
      console.warn('Failed to fetch filters');
      return { shops: [], categories: [] };
    }
  });
  
  // Search mutation - using the sample data for now
  const { mutate, isLoading } = useMutation('search', api.search, {
    onSuccess: (data) => {
      setstate({ ...state, ...data });
    },
    onError: () => {
      // Filter the sample data based on search input
      const filteredProducts = sampleServices.filter(product => 
        product.name.toLowerCase().includes(search.toLowerCase())
      );
      setstate({ ...state, products: filteredProducts });
    }
  });

  const [focus, setFocus] = React.useState(true);
   const slugs = React.useMemo(() =>
    state.products?.map((item) => item?.slug).filter(Boolean) || []
    , [state.products]);
  const { data: detailedProducts, isLoading: isLoadingDetails } = useQuery(
    ['get-detailed-products', slugs],
    async () => {
      const products = await Promise.all(
        slugs.map(async (slug) => {
          try {
            const product = await api.getProductBySlug(slug);
            return product;
          } catch (error) {
            console.error('Error fetching product for slug:', slug, error);
            return null;
          }
        })
      );
      return products.filter((product) => product);
    },
    {
      enabled: slugs.length > 0,
      onError: (error) => {
        console.error('Error fetching detailed products:', error);
      },
      onSuccess: (data) => {
        // console.log('Query succeeded with data:', data); // Debug log
      }
    }
  );
    const getCurrentProductDetails = (productSlug) => {
    return detailedProducts?.find(detailedProduct =>
      detailedProduct?.data?.slug === productSlug
    );
  };

  const hasNoPriceTag = (productSlug) => {
    const productDetails = getCurrentProductDetails(productSlug);
    return productDetails?.data?.tags?.some(tag => tag.includes('no-price'));
  };
const handleListItemClick = (prop) => {
  if (multiSelect) {
    const matched = state.selected.filter((v) => prop._id === v._id);
    const notMatched = state.selected.filter((v) => prop._id !== v._id);
    if (Boolean(matched.length)) {
      setstate({ ...state, selected: notMatched });
    } else {
      setstate({ ...state, selected: [...state.selected, prop] });
    }
  } else {
    !mobile && onClose(prop);
     const slugToUse = typeof prop === 'string' ? prop : prop?.slug;
    const productDetails = getCurrentProductDetails(slugToUse);
    const slugToCheck = productDetails?.data?.slug || slugToUse;
    const linkTo = slugToCheck?.startsWith('12months-premium')
        ? '/services-x'
        : slugToCheck?.startsWith('cg-trending')
          ? '/services-cglisting'
          : slugToCheck?.startsWith('cg-listing')
            ? '/services-cglisting'
            : slugToCheck?.startsWith('apple-gift-cards')
              ? '/services-appstore'
              : slugToCheck?.startsWith('google-play-gift-cards')
                ? '/services-googleplay'
                : slugToCheck?.startsWith('amazon-gift-cards')
                  ? '/services-amazon'
                : slugToCheck?.startsWith('mobile-topup')
                  ? '/services-topup'
                  : slugToCheck?.startsWith('telegram-premium-subscription')
                    ? '/services-telegram'
                    : slugToCheck?.startsWith('1-video-twitter-post')
                      ? '/services-nfinity'
                      : (productDetails?.category?.name === 'Services' || (typeof prop === 'object' && prop?.category?.name === 'Services'))
                        ? '/services-sectbot'
                        : `/product/${slugToCheck || ''}`;
    
      
      window.open(`https://app.aicm.store${linkTo}`, '_blank');

  }
  
};


 
          
  const onKeyDown = (e) => {
    if (e.keyCode === 38 || e.keyCode === 40) {
      setFocus(false);
    }
  };
  
  React.useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      try {
        mutate({ query: search, category: state.category, subCategory: state.subCategory, shop: state.shop });
      } catch (err) {
        const filteredProducts = sampleServices.filter(product => 
          product.name.toLowerCase().includes(search.toLowerCase())
        );
        setstate({ ...state, products: filteredProducts });
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [search]);
  
  React.useEffect(() => {
    try {
      mutate({ query: search, category: state.category, subCategory: state.subCategory, shop: state.shop });
    } catch (err) {
      // Filter by category as fallback
      const filteredProducts = sampleServices;
      setstate({ ...state, products: filteredProducts });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.category, state.subCategory, state.shop]);

  // Format currency function
  const formatCurrency = (amount) => {
    return `$${amount.toFixed(2)}`;

  };
// console.log('formatCurrency',formatCurrency)
  return (
    <>
      <TextField
        id="standard-basic"
        variant="standard"
        placeholder="Search products"
        onFocus={() => setFocus(true)}
        onKeyDown={onKeyDown}
        onChange={(e) => {
          setSearch(e.target.value);
          setstate({ ...state, initialized: true });
        }}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" sx={{ justifyContent: 'center' }}>
              {isLoading ? (
                <CircularProgress sx={{ width: '24px !important', height: '24px !important' }} />
              ) : (
                // Search icon SVG
                <SearchIcon src={popupsearch} alt="search icon"  />
              )}
            </InputAdornment>
          )
        }}
        sx={{
          ...(mobile && {
            position: 'sticky',
            top: 0,
            zIndex: 1,
            bgcolor: 'background.paper'
          }),
          '& .MuiInput-root': {
            height: { lg: 72, md: 72, sm: 72, xs: 56 }
          },
          '& .MuiInputAdornment-root': {
            width: 100,
            mr: 0,
            svg: {
              mx: 'auto',
              color: 'primary.main'
            }
          }
        }}
      />
      <Divider sx={{backgroundColor: '#DBEBFF', border: '1px solid #DBEBFF' }} />
      <Box className="scroll-main">
        <Box sx={{ height: mobile ? 'auto' : '342px', overflow: 'auto' }}>
          {state.initialized && !isLoading && !Boolean(state.products.length) && (
            <>
              <Stack
                justifyContent="center"
                alignItems="center"
                sx={{
                  p: 4,
                  svg: {
                    width: 300,
                    height: 380
                  }
                }}
              >
                <Typography color="text.secondary">No products found</Typography>
              </Stack>
            </>
          )}

          {!isLoading && !Boolean(state.products.length) ? (
            ''
          ) : (
            <>
              <MenuList
                sx={{
                  pt: 0,
                  mt: 1,
                  overflow: 'auto',
                  px: 1,
                  li: {
                    borderRadius: '8px',
                    border: `1px solid transparent`,
                    cursor: 'pointer', 
                    '&:hover, &.Mui-focusVisible, &.Mui-selected ': {
                      border: (theme) => `1px solid ${theme.palette.primary.main}`,
                      bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                      h6: {
                        color: 'primary.main'
                      }
                    },
                    '&.active': {
                      border: (theme) => `1px solid ${theme.palette.primary.main}`,
                      bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                      h6: {
                        color: 'primary.main'
                      }
                    }
                  }
                }}
                autoFocusItem={!focus}
              >
                {(isLoading ? Array.from(new Array(mobile ? 6 : 8)) : state.products).map((product, index) => (
                  <MenuItem
                    key={product?._id || index}
                    className={Boolean(state.selected.filter((v) => v._id === product?._id)?.length) ? 'active' : ''}
                    onClick={() => product && handleListItemClick(multiSelect ? product : product?.slug)}
                  >
                    <ListItemIcon>
                      {isLoading ? (
                        <Skeleton variant="circular" width={40} height={40}  />
                      ) : (
                        product?.image?.url ? (
                          <BlurImageAvatar
                            alt={product.name}
                            src={product.image.url}
                          />
                        ) : (
                          <Avatar sx={{ bgcolor: 'primary.light' }}>
                            {product?.name?.charAt(0) || '?'}
                          </Avatar>
                        )
                      )}
                    </ListItemIcon>
                    <ListItemText>
                     <Stack direction="row" gap={1} alignItems={'center'} justifyContent={'space-between'}>
                        <div>
                          <Typography variant="subtitle1" color="text.primary" noWrap>
                            {isLoading ? <Skeleton variant="text" width="200px" /> : product.name}
                          </Typography>
                          <Typography variant="body2" color="text.secondary" noWrap>
                            {isLoading ? <Skeleton variant="text" width="200px" /> : product.category}
                          </Typography>
                        </div>
                        {hasNoPriceTag(product?.slug) ? (
                          // Products with 'no-price' tag show price range
                          <Typography color="text.primary">
                            ETH 0.001 - 0.1
                          </Typography>
                        ) : SecbotServices.categories.SecbotAlertProducts.includes(product?._id) ? (
                          // Products that need ETH price conversion
                          <Typography color="text.primary">
                            ETH {(product?.priceSale / ethPrice).toFixed(3)}
                          </Typography>
                        ) : SecbotServices.NonSecbotAlertProducts.includes(product?._id) ? (
                          // Products with fixed price (no conversion needed)
                          <Typography color="text.primary">
                          ETH {product?.priceSale}
                            </Typography>
                        ) : (
                          // Default case for other products
                          <Typography variant="subtitle1" color="text.primary" noWrap>
                            {isLoading ? (
                              <Skeleton variant="text" width="100px" />
                            ) : (
                              <Typography color="text.primary">
                              `$(${product.priceSale})`
                          </Typography>
                            )}
                          </Typography>
                        )}
                      </Stack>
                    </ListItemText>
                  </MenuItem>
                ))}
              </MenuList>
            </>
          )}
        </Box>
        {multiSelect && (
          <Stack gap={1} direction={'row'} p={1} justifyContent={'end'}>
            <Button variant="outlined" color="primary" onClick={() => handleSave(selectedProducts)}>
              Cancel
            </Button>
            <Button variant="contained" color="primary" onClick={() => handleSave(state.selected)}>
              Save
            </Button>
          </Stack>
        )}
      </Box>
    </>
  );
}